export default __webpack_public_path__ + "static/media/project_construction.c0ff3c52.svg";